<template>
    <div class="float-left">

        <i
            class="fa fa-info-circle fa-lg icon-button"
            title="Detalhes"
            @click.stop="abrirModal()"
        ></i>

        <b-modal
            id="modalDetalhesProcessosAtaDirex"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
        >
            <div slot="modal-title">
                Processo Ata Direx - <b-badge variant="warning">DETALHES</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <!-- Dados da Ata -->
            <!-- <b-card> -->
            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="cdTipoAta">Tipo Ata</label>
                        <b-form-select
                                id="cdTipoAta"
                                type="text"
                                :options="tipoAta"
                                value-field="key"
                                text-field="label"
                                v-model="ataDirex.cdTipoAta"
                                :disabled="true"
                            >
                            </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="nuAtaDirex">Ata Direx</label>
                        <b-form-input
                            id="nuAtaDirex"
                            type="text"
                            placeholder="99/9999"
                            v-model="ataDirex.nuAtaDirex"
                            v-mask="[
                                        '##/####'
                                    ]"
                            :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="dtReuniao">Data Reunião</label>
                        <b-input-group>
                            <date-picker
                                id="dtReuniao"
                                v-model="ataDirex.dtReuniao"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                                :disabled="true"
                            ></date-picker>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- <hr/> -->
            <!-- </b-card> -->
            <!-- Fim Dados da Ata -->

            <!-- Dados Processo -->
            <b-row>

                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="nuProcesso">Processo</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                id="nuProcesso"
                                v-mask="'############'"
                                @keyup="obterProcessoPorNumero()"
                                placeholder="Digite o número do processo"
                                v-model="processoAtaDirexDto.nuProcesso"
                                :disabled="true"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="situacaoProcesso">Situação</label>
                        <b-form-input
                            id="situacaoProcesso"
                            type="text"
                            v-model="processoAtaDirexDto.situacaoProcesso"
                            :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="interessadoGEDOC">Interessado GEDOC</label>
                        <b-form-input
                            id="interessadoGEDOC"
                            type="text"
                            v-model="this.interessadoGEDOC"
                            :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="criadoPorGEDOC">Criado por no GEDOC</label>
                        <b-form-input
                            id="criadoPorGEDOC"
                            type="text"
                            v-model="this.criadoPorGEDOC"
                            :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="unidadeGEDOC">Unidade GEDOC</label>
                        <b-form-input
                            id="unidadeGEDOC"
                            type="text"
                            v-model="this.unidadeGEDOC"
                            :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="12">
                    <b-form-group>
                        <label for="vcObjetoProcesso">Objeto GEDOC</label>
                        <b-input-group>
                            <b-form-textarea
                                id="vcObjetoProcesso"
                                type="text"
                                v-model="processoAtaDirexDto.vcObjetoProcesso"
                                placeholder="Objeto"
                                :rows="4"
                                :disabled="true"
                            ></b-form-textarea>
                            <b-form-invalid-feedback>Objeto é obrigatório</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label for="idTipoContrato">Tipo</label>
                        <b-form-select
                                id="idTipoContrato"
                                type="text"
                                :options="tipoContrato"
                                value-field="key"
                                text-field="label"
                                v-model="processoAtaDirexDto.idTipoContrato"
                                :disabled="true"
                            >
                            </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label for="nuFolhaAtaDirex">Folha</label>
                        <b-form-input
                            id="nuFolhaAtaDirex"
                            v-mask="'############'"
                            type="text"
                            v-model="processoAtaDirexDto.nuFolhaAtaDirex"
                            :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="codSolicitante">Solicitante</label>
                        <b-form-select
                                id="codSolicitante"
                                type="text"
                                :options="solicitantes"
                                value-field="codFuncionario"
                                text-field="nome"
                                v-model="processoAtaDirexDto.codSolicitante"
                                :disabled="true"
                            >
                            </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="codUnidade">Unidade</label>
                        <b-form-select
                                id="codUnidade"
                                type="text"
                                :options="unidades"
                                value-field="codUnidade"
                                text-field="nome"
                                v-model="processoAtaDirexDto.codUnidade"
                                :disabled="true"
                            >
                            </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="nuValorGlobalProcesso">Valor Total</label>
                        <b-input-group>
                            <money
                                id="nuValorGlobalProcesso"
                                v-model="processoAtaDirexDto.nuValorGlobalProcesso"
                                v-bind="money"
                                class="form-control text-right"
                                :disabled="true"
                            ></money>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="vcAtaCancelamento"
                                v-if="processoCancelado"
                        >Ata Direx de Cancelamento</label>
                        <b-form-input
                            id="vcAtaCancelamento"
                            type="text"
                            placeholder="99/9999"
                            v-model="processoAtaDirexDto.vcAtaCancelamento"
                            v-mask="[
                                        '##/####'
                                    ]"
                            :disabled="true"
                            v-if="processoCancelado"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="12">
                    <b-form-group>
                        <label for="vcMotivoCancelamento"
                               v-if="processoCancelado"
                        >Motivo do Cancelamento</label>
                        <b-input-group>
                            <b-form-textarea
                                id="vcMotivoCancelamento"
                                type="text"
                                v-model="processoAtaDirexDto.vcMotivoCancelamento"
                                placeholder="Motivo do Cancelamento"
                                :rows="4"
                                :disabled="true"
                                v-if="processoCancelado"
                            ></b-form-textarea>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <!-- Fim Dados Processo -->

            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
    import AtaDirexServicos from '../AtaDirexServicos'
    //import { required, minValue } from 'vuelidate/lib/validators'

    export default {
        props: {
            ProcessoAtaDirexPai: Object,
            modoCadastro: Boolean,
            processoCancelado: Boolean,
        },

        data(){
            return {
                mostrarModal: false,
                erros: [],
                ataDirex: {},
                solicitantes: [],
                unidades: [],

                interessadoGEDOC: '',
                criadoPorGEDOC: '',
                unidadeGEDOC: '',

                tipoAta: [
                    {
                        key: '1',
                        label: 'Ordinária',
                    },
                    {
                        key: '2',
                        label: 'Extraordinária',
                    }
                ],
                tipoContrato: [
                    {
                        key: '1',
                        label: 'Contrato',
                    },
                    {
                        key: '2',
                        label: 'Convênio',
                    }
                ],
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                processoAtaDirexDto: {
                    idProcessoAta:0,
                    idAtaDirex: this.$route.params.idAtaDirex,
                    nuProcesso: null,
                    nuFolhaAtaDirex: null,
                    vcObjetoProcesso: null,
                    vcNomeSolicitanteGdoc: null,
                    idTipoContrato:null,
                    codUnidade:null,
                    codSolicitante:0,
                    nuValorGlobalProcesso:0,
                    dtCadastro:null,
                    idSituacaoProcesso:0,
                    usrLoginCadastro:null,
                    vcAtaCancelamento:null,
                    vcMotivoCancelamento:null,
                    situacaoProcesso:null
                },
            }
        },

        methods: {

            addZeroes (num, len) {
                var numberWithZeroes = String(num);
                var counter = numberWithZeroes.length;

                while(counter < len) {
                    numberWithZeroes = "0" + numberWithZeroes;
                    counter++;
                }

                return numberWithZeroes;
            },

            obterAtaDirex() {
                this.$store.dispatch('addRequest')
                AtaDirexServicos.ObterInformacoesGeraisAta(this.$route.params.idAtaDirex).then(
                    response => {
                        if (response) {
                            if (response.success) {
                                this.ataDirex = response.data
                                this.ataDirex.dtReuniao = this.$moment(this.ataDirex.dtReuniao, 'YYYY-MM-DD').format('DD/MM/YYYY')
                            } else {
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    }
                )
            },

            limpar(){
                this.processoAtaDirexDto.idProcessoAta=0
                this.processoAtaDirexDto.idAtaDirex= this.$route.params.idAtaDirex
                this.processoAtaDirexDto.nuProcesso= null
                this.processoAtaDirexDto.nuFolhaAtaDirex= null
                this.processoAtaDirexDto.vcObjetoProcesso= null
                this.processoAtaDirexDto.vcNomeSolicitanteGdoc= null
                this.processoAtaDirexDto.idTipoContrato=null
                this.processoAtaDirexDto.codUnidade=null
                this.processoAtaDirexDto.codSolicitante=0
                this.processoAtaDirexDto.nuValorGlobalProcesso=0
                this.processoAtaDirexDto.dtCadastro=null
                this.processoAtaDirexDto.idSituacaoProcesso=0
                this.processoAtaDirexDto.usrLoginCadastro=null
                this.processoAtaDirexDto.vcAtaCancelamento=null
                this.processoAtaDirexDto.vcMotivoCancelamento=null
                this.processoAtaDirexDto.situacaoProcesso=null

                this.interessadoGEDOC=null
                this.criadoPorGEDOC=null
                this.unidadeGEDOC=null
            },

            Carregar(){
                this.processoAtaDirexDto.idProcessoAta= this.ProcessoAtaDirexPai.idProcessoAta
                this.processoAtaDirexDto.idAtaDirex= this.ProcessoAtaDirexPai.idAtaDirex
                this.processoAtaDirexDto.nuProcesso= this.ProcessoAtaDirexPai.nuProcesso
                this.processoAtaDirexDto.nuFolhaAtaDirex= this.ProcessoAtaDirexPai.nuFolhaAtaDirex
                this.processoAtaDirexDto.vcObjetoProcesso= this.ProcessoAtaDirexPai.vcObjetoProcesso
                this.processoAtaDirexDto.vcNomeSolicitanteGdoc= this.ProcessoAtaDirexPai.vcNomeSolicitanteGdoc
                this.processoAtaDirexDto.idTipoContrato= this.ProcessoAtaDirexPai.idTipoContrato
                this.processoAtaDirexDto.codUnidade= this.addZeroes(this.ProcessoAtaDirexPai.codUnidade, 3) //this.ProcessoAtaDirexPai.codUnidade
                this.processoAtaDirexDto.codSolicitante= this.ProcessoAtaDirexPai.codSolicitante
                this.processoAtaDirexDto.nuValorGlobalProcesso= this.ProcessoAtaDirexPai.nuValorGlobalProcesso
                this.processoAtaDirexDto.dtCadastro= this.$moment(this.ProcessoAtaDirexPai.dtCadastro).format('DD/MM/YYYY');
                this.processoAtaDirexDto.idSituacaoProcesso=this.ProcessoAtaDirexPai.idSituacaoProcesso
                this.processoAtaDirexDto.usrLoginCadastro=this.ProcessoAtaDirexPai.usrLoginCadastro
                this.processoAtaDirexDto.vcAtaCancelamento=this.ProcessoAtaDirexPai.vcAtaCancelamento
                this.processoAtaDirexDto.vcMotivoCancelamento=this.ProcessoAtaDirexPai.vcMotivoCancelamento
                this.processoAtaDirexDto.situacaoProcesso=this.ProcessoAtaDirexPai.situacaoProcesso
            },

            abrirModal() {
                this.limpar();
                this.obterAtaDirex();
                this.listarUnidades();
                this.listarSolicitantes();
                this.mostrarModal = true;
                this.Carregar();
                this.obterProcessoPorNumero();
            },

            fecharModal() {
                this.mostrarModal = false;
            },

            listarSolicitantes(){
                this.$store.dispatch('addRequest')
                AtaDirexServicos.ListarFuncionariosRM(this.ProcessoAtaDirexPai.codSolicitante)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.solicitantes = response.data
                        }
                        else{
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            },

            listarUnidades(){
                this.$store.dispatch('addRequest')
                AtaDirexServicos.ListarUnidadesRM()
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.unidades = response.data
                        }
                        else{
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            },

            obterProcessoPorNumero() {
                this.erros = []
                if (this.processoAtaDirexDto.nuProcesso!=null && this.processoAtaDirexDto.nuProcesso.length == 12) {
                    this.$store.dispatch('addRequest')
                    AtaDirexServicos.obterProcessoGedocPorNumero(
                        this.processoAtaDirexDto.nuProcesso
                    ).then(response => {
                        if (response) {
                            if (response.success && response.data != null) {
                                this.interessadoGEDOC = response.data.nome
                                this.criadoPorGEDOC = response.data.cadastradoPor
                                this.unidadeGEDOC = response.data.unidade
                            } else {
                                this.erros.push('Processo não encontrado')
                                this.interessadoGEDOC=null
                                this.criadoPorGEDOC=null
                                this.unidadeGEDOC=null
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    })
                }
                else{
                    this.interessadoGEDOC=null
                    this.criadoPorGEDOC=null
                    this.unidadeGEDOC=null
                    if (this.erros.length > 0) {
                        this.erros = []
                    }
                }
            },

        },
    }
</script>
